// 編輯頁（製作）看審查流程用的小規則：決定記在哪一版、哪些狀態現在不能選、歌單上的階段小標。
import type { Song } from './api';
import { GATE_NOT_RELEASED, GATE_STAGE_LABEL } from './reviewGate';
import type { GateStage } from './reviewGate';

type GateSong = Pick<Song, 'gate'>;

/** 通過 / 需修改記在導演看的那一版（放行版）；沒有放行版 = null */
export function reviewVideoIdFor(song: GateSong): string | null {
  return song.gate?.releasedVideoId ?? null;
}

/** 通過、需修改要先放行；後台沒回 gate（舊版後台）就不擋。擋的話回原因，不擋回 null */
export function statusBlockedReason(song: GateSong, status: Song['status']): string | null {
  if (status !== 'approved' && status !== 'needs_changes') return null;
  if (!song.gate) return null;
  return song.gate.releasedVideoId ? null : GATE_NOT_RELEASED;
}

/** 歌單項目的階段小標；沒有階段資料 = null */
export function gateStageTag(song: GateSong): { label: string; stage: GateStage } | null {
  const stage = song.gate?.stage;
  if (!stage) return null;
  return { label: GATE_STAGE_LABEL[stage], stage };
}

/** 「有新版」小標的提示：導演現在看的是哪一版 */
export function newerVersionTitle(song: GateSong): string {
  const v = song.gate?.releasedVersion;
  return v != null ? `導演目前看 V${v}` : '還沒有給導演看的版本';
}

